var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"8px"}},[_vm._v("\n  Note: This is a number assigned by local govermment agencise to identify a business entity within the local market. For example: the CNPJ in Brazil, the SIRET in France, etc.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }